export const PURCHASE_AGREEMENT_DOCUMENT_TYPE_NAME = 'Purchase Agreement';

export const REGGORA_SUPPORTING_DOCUMENTS_DESCRIPTION =
  'Uploaded to the new Reggora order: the newest document of each type on the loan. A type with no document on the loan is skipped. Purchase Agreement is sent by default.';
